module.exports = __webpack_public_path__ + "static/img/Wj.c054ba6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Wj.jpg
// module id = 6LD9
// module chunks = 1